var $a2df6279fd2913da$exports = {};
$a2df6279fd2913da$exports = {
    "valid": `Valido`
};


export {$a2df6279fd2913da$exports as default};
//# sourceMappingURL=it-IT.mjs.map
